// extracted by mini-css-extract-plugin
export default {"image":"yW-z","loaded":"zW-z"};